<template>
    <!-- Hero Sections Here -->
   <section class="banner__breadcumn ralt">

<!--Search Popup-->
<div id="searchPopup" class="search__popup">
   <form action="#" class="popup-content d-flex align-items-center">
      <input type="text" placeholder="Search Here">
      <button id="closeButton">
         <i class="bi bi-x-lg"></i>
      </button>
   </form>
</div>
<!--Search Popup-->

<div class="breadcumnd__wrapper">
   <div class="container">
      <div class="profile__wrapper">
         <div class="row g-4 align-items-center justify-content-between">
            <div class="col-xxl-6 col-xl-6 col-lg-7 col-md-7 col-sm-7">
               <div class="breadcumnd__content">
                  <span class="d41 mb-24">
                     Yangiliklar
                  </span>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
</section>
<!-- Hero Section End -->

<!-- Blog Categories Here -->
<section class="blog__sections sectionbg pt-60 pb-120">
<div class="container">
   <div class="row g-4">
      <div class="col-xl-8 col-lg-8">
         <div class="balance__transfercard shadow1 p-8 bgwhite mb-24 round16">
            <div class="bt__one mb-20">
               <img src="assets/img/service/e38d18fbac6a40a5a905a396029bc51f.png" alt="balance" class="round16 w-101">
            </div>
            <div class="blog__content">
               <ul class="blog__addmin flex-wrap mb-24 d-flex align-items-center">
                  <li class="fz-18 ralt fw-400 inter ptext2 d-flex align-items-center gap-2">
                        16.10.2024  
                  </li>
                  <li class="fz-18 ralt fw-400 inter ptext2 d-flex align-items-center gap-2">
                     243
                  </li>            
               </ul>
               <h3 class="title mb-24">
                “ANTIKORRUPSIYA/расмий” telegram-kanalida 2024-yil 16-oktyabr sanasida 13:26 da “Pochta bo‘linmasi sotilganligi tasdiqlanmoqda” sarlavhasi bilan joylashtirilgan postga nisbatan RASMIY MUNOSABAT
               </h3>
               
               <p class="fz-16 fw-400 inter pra">
                2024-yil 15-oktyabr sanasida “O‘zbekiston pochtasi” AJga tegishli saytda joylashtirilgan munosabatda shuni ta’kidlab o‘tgan edikki, “O‘zbekiston pochtasi” AJga qarashli binolarni O‘zbekiston Respublikasi Prezidentining 2022-yil 18-martda qabul qilingan PQ-168-sonli “Iqtisodiyotda davlat ishtirokini yanada qisqartirish va hususiylahtirishni jadallashtirishga oid qo‘shimcha chora-tadbirlar to‘g‘risida” qarori ijrosini ta’minlash maqsadida, Davlat aktivlarini boshqarish agentligiga topshirish, foydalanilmayotganlarini sotish, davlat-xususiy sherikchilik asosida qayta qurish faqatgina “O‘zbekiston pochtasi”AJ qaror qabul qiluvchi organi – Kuzatuv kengashiga topshirilgan. “O‘zbekiston pochtasi” AJ (keyingi o‘rinlarda “Jamiyat”) Kuzatuv kengashining 2022-yil 14-iyundagi yig‘ilish qaroriga muvofiq hamda Jamiyatning 2022-yil 29-iyundagi 127-son buyrug‘iga binoan, 325 ta tashkilotga tegishli binolarni sotuvga chiqarish belgilangan. 
               </p>
               <br>
               <p class="fz-16 fw-400 inter pra">
                Maqolada keltirilgan Farg‘ona filiali balansidagi Marg‘ilon shahar, Asilobod ko‘chasi, 205a-uy manzilidagi, 9-son pochta aloqasi bo‘limi binosining foydali maydoni 16,4 kvadrat metrni tashkil etgan. Kuzatuv kengashi qaroriga asosan sotilishi belgilangan binoni qonunchilikda belgilangan tartibda sotish maqsadida, baholash va ekspertizadan o‘tkazish ishlari amalga oshirilishi uchun maxsus litsenziyaga ega tashkilot, “VEN VIDI VALUATION” MCHJ tomonidan baholash ishlari olib borilgan va 28,635 mln so‘mga baholangan. 2022-yil 17-oktyabrda taqdim etilgan ko‘chmas mulklarni baholash hisobotlari mutlaqo betaraf “DISKONT - INVEST” MCHJ tomonidan ekspertiza o‘tkazilgan. 2023-yil 26-yanvarda taqdim etilgan baholash hisobotlari va ekspertiza xulosalariga asosan (baholash hisobotlari va ekspertiza xujjatlari ilova qilinadi) mazkur bino qonunchilikda o‘rnatilgan tartibda “E-AUKSION” davlat korxonasi yagona elektron savdo platformasi orqali    2023-yil 13-iyul kuni sotuvga qo‘yilgan. “E-AUKSION” faoliyatidan maqsad – yuridik va jismoniy shaxslarning buyurtmalariga asosan auksion (tanlov) savdolarini tashkil etish va o‘tkazishda qonuniylik hamda shaffoflikni ta’minlash hisoblanadi va bunga amal qilinadi.               
                </p>
                <br>
                <p class="fz-16 fw-400 inter pra">
                Ushbu bino narxi 2023-yil 21-noyabr sanasigacha savdo bo‘lmaganligi sababli 10% ga tushirilgan va 2023-yil 4-dekabr kuni savdoga qayta qo‘yilgan. Binoga talabgorlar chiqmaganligi sababli 2024-yil 12-fevral kuni narxi yana 10% ga tushirilib, qayta savdoga qo‘yilgan va bino 2024-yil 20-may sanasida fuqaro G‘iyosjon G‘ofurov tomonidan auksion savdo platformasida 25,513 mln so‘mga sotib olingan.
               </p>
               <br>
               <p class="fz-16 fw-400 inter pra">
                Bu bilan shuni ta’kidlab o‘tmoqchimizki, albatta ishlamay turgan ba’zi binolarimizni sotganmiz, ammo bu doim rasmiy “E-AUKSION” savdo platformasi orqali hamda yuqoridagi kabi barcha qonun va qoidalarga rioya qilingan holda amalga oshirilgan. Demak, hech qanday korrupsiya yoki o‘zaro kelishuvlar yoki manfaatlar to‘qnashuvi haqida gap ham bo‘lishi mumkin emas. Ushbu bino va “Jamiyat” ga tegishli bo‘lgan “E-AUKSION” platformasida sotilgan barcha binolar oldi-sotdi ishlari 100% shaffof tarzda o‘tkazilgan. “E-AUKSION” elektron savdo platformasining operatori - O‘zbekiston Respublikasi Davlat aktivlarini boshqarish agentligi tasarrufidagi “Elektron onlayn-auksionlarni tashkil etish” aksiyadorlik jamiyatidir.
                </p>
                <br>
                <p class="fz-16 fw-400 inter pra">
                    Shunday ekan sizdan yolg‘on xabarlar tarqatmaslikni so‘raymiz. O‘zbekiston qonunchiligiga ko‘ra yolg‘on xabarlar tarqatilishi jinoiy javobgarlikka tortilishi uchun asos bo‘lishini ma’lum qilamiz.                 
                </p>
                <p class="fz-16 fw-400 inter pra">
                    Agarda ushbu masalada yana savollaringiz bo‘lsa, ish kunlari sizni 09:00 dan 18:00ga qadar UzPost bosh offisida kutamiz!
                </p>
            </div>
         </div>
         
         <div class="trending__based bgwhite round16 shadow1">
            <h4 class="pb-24 title bborderdash mb-24">
               Izoh qoldiring
            </h4>
            <form action="#0" class="writing__review">
               <div class="wrigt__grp">
                  <label for="name">Ism</label>
                  <input type="text" id="name" placeholder="Ismingizni kiriting">
               </div>
               <div class="wrigt__grp">
                  <label for="email">Email</label>
                  <input type="text" id="email" placeholder="Email manzil kiriting...">
               </div>
               <div class="wrigt__grp">
                  <label for="name">Izoh</label>
                  <textarea class="form-control" placeholder="izoh yozib qoldiring" id="textAreaExample"
                     rows="4"></textarea>
               </div>
               <button class="cmn--btn mt-16">
                  <span>
                     Yuborish
                  </span>
                  <span>
                     <i class="bi bi-arrow-up-right"></i>
                  </span>
               </button>
            </form>
         </div>
      </div>
      <div class="col-xl-4 col-lg-4">
                    <div class="blog__sidebar">
                        <div class="blog__common__item bgwhite round16 mb-24">
                            <h4 class="head fw-600 bborderdash title pb-24 mb-24">
                                Ko‘p ko‘rilgan maqolalar
                            </h4>
                            <ul class="recent__post">
                                <li>
                                    <a href="/yangilik5"
                                        class="recent___item bborderdash mb-24 pb-24 d-flex align-items-center">
                                        <span class="cateicon">
                                            <img src="assets/img/service/ustozlar.jpg" alt="round"
                                                style="width: 100px; height: 90px;">
                                        </span>
                                        <span class="fz-20 post__content fw-600 title inter">
                                            21-oktyabr – O‘zbek tili bayrami kuni
                                            <span class="d-block fz-18 fw-400 base inter">
                                                21.10.2024
                                            </span>
                                        </span>
                                    </a>
                                </li>
                                <li>
                                    <a href="/yangilik2"
                                        class="recent___item mb-24 bborderdash pb-24 d-flex align-items-center">
                                        <span class="cateicon">
                                            <video class="round16 w-101" controls style="width: 80px; height: 100px;">
                                                <source src="/assets/img/service/12.MP4" type="video/mp4">
                                                Sizning brauzeringiz video formatni qo'llab-quvvatlamaydi.
                                            </video>
                                        </span>
                                        <span class="fz-20 post__content fw-600 title inter">
                                            18-noyabr Davlat bayrog‘i kuni ...
                                            <span class="d-block fz-18 fw-400 base inter">
                                                18.11.2024
                                            </span>
                                        </span>
                                    </a>
                                </li>
                                <li>
                                    <a href="/yangilik4"
                                        class="recent___item mb-24 bborderdash pb-24 d-flex align-items-center">
                                        <span class="cateicon">
                                            <img src="assets/img/service/1e4563610069470abf302b7759b7179d.jpg"
                                                alt="round" style="width: 100px; height: 90px;">
                                        </span>
                                        <span class="fz-20 post__content fw-600 title inter">
                                            “O‘zbekiston pochtasi” AJ aksiyadorlarining ...
                                            <span class="d-block fz-18 fw-400 base inter">
                                                13.11.2024
                                            </span>
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="blog__common__item bgwhite round16">
                            <h4 class="head fw-600 bborderdash title pb-24 mb-24">
                                Bizni kuzatib boring
                            </h4>
                            <ul class="social d-flex align-items-center">
                                <li>
                                    <a href="https://www.facebook.com/uzpochta">
                                        <i class="bi bi-facebook"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/uzpost_/">
                                        <i class="bi bi-instagram"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://t.me/uzpostuz">
                                        <i class="bi bi-telegram"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
   </div>
</div>
</section>
<!-- Blog Categories End -->
</template>